import React, { useEffect, useState } from 'react';
import { VDSManager } from '@vds/utilities'
import { Title } from '@vds/typography';
import styled from 'styled-components';
import PropTypes from 'prop-types';
const StyledTitle = styled.div`
padding-bottom: 32px;
`
const ProgressTab = styled.div`
padding: 24px 0px 36px 0px;
`
const Tabs = styled.div`
display: flex;
padding-top: 10px;
`
const Tab = styled.div`
background-color: ${props => props.color};
height: 3px;
width: 33%;
margin-right: 5px;
`

const Header = ({ pageTitle, progressData }) => {

    const [progressTitle, setProgressTitle] = useState();

    useEffect(() => {
        setProgressTitle(getTitle(progressData?.stepsCompleted))
    }, [])

    const getTitle = (steps) => {
        
        const tabs = progressData?.tabs || [];
        const [step1, step2, step3] = tabs;
        switch (steps) {
            case "1": return step1;
            case "2": return step2;
            case "3": return step3;
        }
    }

    return (
        <>
            <VDSManager />
            <StyledTitle >
                <Title size="XLarge" primitive="h1"> {pageTitle} </Title>
            </StyledTitle>
            <ProgressTab>
                <Title size="small" primitive="h2">{progressTitle} </Title>
                <Tabs>
                    <Tab color={"#EE0000"}>
                    </Tab>
                    <Tab color={parseInt(progressData?.stepsCompleted) >= 2 ? "#EE0000" : "#D8DADA"}>
                    </Tab>
                    <Tab color={parseInt(progressData?.stepsCompleted) > 2 ? "#EE0000" : "#D8DADA"}>
                    </Tab>
                </Tabs>
            </ProgressTab>
        </>

    )

}
Header.propTypes = {
    pageTitle:  PropTypes.string.isRequired,
    progressData: PropTypes.object,
};

export default Header;